module.exports = __webpack_public_path__ + "img/MikeCash.7e69f839.jpg";